import {useNavigate, useParams} from "react-router-dom"
import {useEffect, useState} from "react"

import {paymentAPI} from "@indebted/api/paymentAPI"
import {LoadingPage} from "@indebted/components/Loading"
import {ErrorPage} from "@indebted/components/Error"

function DefaultPaymentMethodPage() {
	const {secureCode} = useParams()
	const navigate = useNavigate()
	const [Component, setComponent] = useState(<LoadingPage />)
	useEffect(() => {
		paymentAPI
			.getDefaultPaymentMethod({secureCode})
			.then((result) => {
				navigate(`/${secureCode}/payment-in-full/${result.DefaultPaymentMethod}`)
			})
			.catch((error) => {
				setComponent(<ErrorPage message={error.Message} error={error} />)
			})
	}, [secureCode, navigate])

	return Component
}

export {DefaultPaymentMethodPage}
